import React from 'react'
import {Grid, Button, Header, Modal, Input} from "semantic-ui-react";
import _ from "lodash";
import {socket} from "../../lib/socketio";
import {isAuthorized, SEQUENCE_OVERRIDES} from '../../lib/authorization';
import {useSelector} from "react-redux";
import {createUserLog} from "../../lib/api";

const SeqMacro =({index, column, data, isCopied, setIsCopied}) => {

    const [envalue, setEnvalue] = React.useState(1);
    const [orvalue, setOrvalue] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const [dataCopy, setDataCopy] = React.useState();
    // const [isCopied, setIsCopied] = React.useState(false);
    const [overrideVisible, setOverrideVisible] = React.useState({'visible': true});
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);

    React.useEffect(() => {
        let interval = setInterval(setOverrideVisiblity, 1000);
        return() => clearInterval(interval);
    }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

    const setOverrideVisiblity = () => {
        setOverrideVisible({...overrideVisible, ['visible']: !overrideVisible.visible});
    }

    React.useEffect(() => {
        if(Object.keys(data).length !== 0 && !isCopied){
            setDataCopy({...data});
            setIsCopied(true);
        }
    }, [data]);

    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setOpen({...open, [id]: false});
    };
    

    const convertValue = (value, tag) => {
        if (value === 0) {
            switch (tag) {
                case 'EN':
                    return "AUTO";
                case "OR":
                    return "OFF";
                default:
                    return "AUTO";
            }
        } else {
            switch (tag) {
                case 'EN':
                    return "MANUAL";
                case "OR":
                    return "ON";
                default:
                    return "MANUAL";
            }
        }
    };

    const radioEnSelect = (obj_arr) => {
        let return_val = '';
        if(typeof dataCopy !== 'undefined') {
            var en = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'EN');
            let value = dataCopy[en.id];
            return_val = (value === 0) ? 'Auto' : 'Manual';
        }
        return return_val
    }

    const radioOrSelect = (obj_arr) => {
        let return_val = '';
        if(typeof dataCopy !== 'undefined') {
            var or = obj_arr.find(el => el.tag_display_name.slice(0, 2) === 'OR');

            let value = dataCopy[or.id];
            return_val = (value === 0) ? 'OFF' : 'ON';
        }
        return return_val
    }

    const handleToggle = (event, id1, id2) => {
        event.preventDefault();
        var writedata = {
            'buttonClickType': 'Set Sequence Overrides',
            'tags': [{'tag_id': id1, 'tag_value': envalue}, {'tag_id': id2, 'tag_value': orvalue}]
        };
        socket.emit('button click', writedata);
        setOpen({...open, [id1]: false});
        if (!electronApp) {
            let log = {
                user_id: user.id,
                powerplant_id: ppid,
                display_id: null,
                datetime: new Date().toISOString(),
                data: JSON.stringify({
                    tag_id: writedata.tags,
                    type: writedata.buttonClickType,
                }),
            };
            createUserLog({ log }).catch(console.error);
        }
    }

    const handleChange = (event, obj_arr) => {
        switch (event.target.id) {
            case 'Auto':
                var auto_en = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'EN');
                var off_or = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'OR');
                setOrvalue(0);
                setEnvalue(0);
                setDataCopy({...dataCopy, [auto_en.id]: 0, [off_or.id]: 0});
                break;
            case 'Manual':
                var manual_en = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'EN');
                setEnvalue(1);
                setDataCopy({...dataCopy, [manual_en.id]: 1});
                break;
            case 'ON':
                var on_or = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'OR');
                setOrvalue(1);
                setDataCopy({...dataCopy, [on_or.id]: 1});
                break;
            case 'OFF':
                var off_or = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'OR');
                setOrvalue(0);
                setDataCopy({...dataCopy, [off_or.id]: 0});
                break;
            default:
                var default_en = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'EN');
                var default_or = obj_arr.find(el => el.tag_display_name.slice(0,2) === 'OR');
                setOrvalue(0);
                setEnvalue(0);
                setDataCopy({...dataCopy, [default_en.id]: 0, [default_or.id]: 0});
                break;
        }
    }

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Grid key={column[i][0].id} columns='2' celled stackable centered padded>
                <p style={{marginTop : '10px'}}>{column[i][0].tag_display_subgroup}</p>
                <div>
                    <Button
                        key='button'
                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, SEQUENCE_OVERRIDES)}
                        content= {'OVERRIDE' + column[i][0].tag_display_name.slice(2)}
                        onClick={() => {
                            setOpen({...open, [column[i][0].id]: true})
                        }}/>
                    <Modal
                        key={column[i][0].id}
                        style={styles.width}
                        open={open[column[i][0].id]}
                        onClose={handleClose[column[i][0].id]}
                        onOpen={handleOpen[column[i][0].id]}>
                        <Modal.Header>SEQUENCE OVERRIDE </Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <Header
                                    style={styles.header}>Override {column[i][0].tag_display_name.slice(2)} </Header>
                                <Header> Enable </Header>
                            </Modal.Description>
                            <form>
                                <Input type='radio'
                                       id='Auto'
                                       label='Auto'
                                       checked={radioEnSelect(column[i]) === 'Auto'}
                                       onChange={(event, value) => handleChange(event,column[i])}
                                       style={styles.checkbox}
                                />
                                <Input type='radio'
                                       id='Manual'
                                       label='Manual'
                                       checked={radioEnSelect(column[i]) === 'Manual'}
                                       onChange={(event, value) => handleChange(event,column[i])}
                                       style={styles.checkbox}
                                />
                            </form>
                        </Modal.Content>
                        <Modal.Content>
                            <Modal.Description>
                                <Header>Override</Header>
                            </Modal.Description>
                            <Input
                                type='radio'
                                id='ON'
                                label='ON'
                                checked={radioOrSelect(column[i]) === 'ON'}
                                onChange={(event, value) => handleChange(event,column[i])}
                                style={styles.checkbox}
                            />
                            <Input
                                type='radio'
                                id='OFF'
                                label='OFF'
                                checked={radioOrSelect(column[i]) === 'OFF'}
                                onChange={(event, value) => handleChange(event,column[i])}
                                style={styles.checkbox}
                            />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id='OK'
                                    content='OK'
                                    onClick={(event, value) => handleToggle(event, column[i][0].id, column[i][1].id)}
                            />
                            <Button color='red' content={'Cancel'}
                                    onClick={() => {
                                        setOpen({...open, [column[i][0].id]: false})
                                    }}/>
                        </Modal.Actions>
                    </Modal>
                    <Grid style ={styles.grid}>
                        {column[i].map(r =>
                            <Grid.Row style={styles.row}>
                                <Grid.Column width = '4' style={{marginLeft: '50px'}}>{r.tag_display_name}</Grid.Column>
                                { r.tag_display_name.slice(0, 2) === 'OR' && data[column[i][0].id] === 1 && overrideVisible.visible ?
                                    <Grid.Column style={{color: 'green'}}>
                                        {convertValue(data[r.id], r.tag_display_name.slice(0, 2))}
                                    </Grid.Column>
                                    :
                                    <Grid.Column style={{color: 'yellow'}}>
                                        {convertValue(data[r.id], r.tag_display_name.slice(0, 2))} </Grid.Column>
                                }
                            </Grid.Row>
                        )}
                    </Grid>
                </div>
            </Grid>
        ))
    ))


    return (
        <Grid.Column key={index} style={{maxWidth: '300px', padding: '0'}}>
            {gridColumn}
        </Grid.Column>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    width: {
        maxWidth: '300px'
    },
    header: {
        marginLeft: '50px'
    },
    checkbox: {
        flexDirection: 'row-reverse'
    },
    grid: {
        padding: '20px'
    },
    row: {
        padding: '0px',
        marginTop: '5px',
        marginBottom: '10px'
    }
}

export default SeqMacro;

